import SiteImage from '../components/SiteImage';
import SectionHeading from '../components/SectionHeading';
import BookingPrompt from '../components/BookingPrompt';
import PropertyOverview from '../components/PropertyOverview';
import { useSiteContent } from '../context/SiteContent';

export default function About() {
  const { site } = useSiteContent();
  return (
    <main>
      <section className="page-hero page-hero-about"><div className="page-width"><span className="eyebrow">A warm welcome</span><h1>About Us</h1><p>Comfort, warmth and hospitality.</p></div></section>
      <section className="about-preview about-page-content section-pad page-width">
        <div className="about-photo-wrap"><SiteImage src={site.images.about} alt="Lounge at K and son’s Guest House" className="about-photo" /></div>
        <div className="about-copy"><span className="eyebrow">Welcome to K and son’s</span><PropertyOverview description={site.about} /></div>
      </section>
      <section className="about-note section-cream section-pad"><div className="page-width"><SectionHeading eyebrow="Made for a slower moment" title="Your stay, your own pace" description="We look forward to making your time with us special." /></div></section>
      <section className="section-pad page-width"><BookingPrompt /></section>
    </main>
  );
}